import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useI18n } from "../i18n";

const FAQ = () => {
  const { t } = useI18n();
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-600 mb-4">
            {t.faq.eyebrow}
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-slate-900">
            {t.faq.title}
          </h2>
        </div>
        <Accordion type="single" collapsible className="w-full space-y-3">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-slate-200 rounded-xl px-6 transition-all hover:border-slate-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display text-base md:text-lg font-semibold text-slate-900 hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
